import { render, staticRenderFns } from "./myCertificate.vue?vue&type=template&id=657388ec&scoped=true"
import script from "./myCertificate.vue?vue&type=script&lang=js"
export * from "./myCertificate.vue?vue&type=script&lang=js"
import style0 from "./myCertificate.vue?vue&type=style&index=0&id=657388ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657388ec",
  null
  
)

export default component.exports